import classes from "./Banner.module.scss";
import Button from "../../../Components/Button/Button";
import ArrowWithTail from "../../../assets/icons/ArrowWithTail";
import { useNavigate } from "react-router-dom";

function Banner() {
  const navigate = useNavigate();

  return (
    <div className={classes.banner}>
      <img
        src="https://se-website-image.s3.ap-south-1.amazonaws.com/clem-ai/banner.png"
        alt="CLEM.ai"
      />

      <div className={classes["banner-text-btn"]}>
        <div className={classes["banner-text"]}>
          <p>
            <span>Where</span>
            <br />
            <span className={classes.bold}>Sustainability</span>
            <br />
            <span>
              meets <span className={classes.bold}>AI</span>
            </span>
          </p>
        </div>

        <Button
          className={classes["get-in-touch-btn"]}
          text={
            <>
              Get in touch <ArrowWithTail width={14} height={10} color="#fff" />
            </>
          }
          btnClickHandler={() => navigate("/contact-us")}
        />
      </div>
    </div>
  );
}

export default Banner;
